/*
 * RESSOURCES HUMAINES — employes, conges, paie, calendrier, et le portail.
 *
 * `employees` et `hr/employees` coexistent : le premier est l'ancien chemin,
 * garde parce que des liens externes et des favoris y pointent. Le supprimer
 * casserait des signets sans rien apporter.
 */
import { Routes } from '@angular/router';
import { permissionGuard } from '../core/guards/permission.guard';
import { moduleGuard } from '../core/guards/module.guard';
import { roleCheckGuard } from '../core/guards/role-check.guard';

export const routesRh: Routes = [
  {
    path: 'hr/leaves',
    loadComponent: () => import('../features/hr/leave-management/leave-management.component').then(m => m.LeaveManagementComponent),
    canActivate: [roleCheckGuard, moduleGuard, permissionGuard],
    data: { requiredPermission: { entity: 'LEAVE', action: 'READ' }, requiredModule: 'hr' }
  },
  {
    path: 'employees',
    loadComponent: () => import('../features/hr/employee-list/employee-list.component').then(m => m.EmployeeListComponent),
    canActivate: [roleCheckGuard, moduleGuard, permissionGuard],
    data: { requiredPermission: { entity: 'EMPLOYEE', action: 'READ' }, requiredModule: 'hr' }
  },
  {
    path: 'employees/:id',
    loadComponent: () => import('../features/hr/employee-detail/employee-detail.component').then(m => m.EmployeeDetailComponent),
    canActivate: [roleCheckGuard, moduleGuard, permissionGuard],
    data: { requiredPermission: { entity: 'EMPLOYEE', action: 'READ' }, requiredModule: 'hr' }
  },
  {
    path: 'hr/employees',
    redirectTo: 'employees',
    pathMatch: 'full'
  },
  {
    path: 'hr/employees/:id',
    redirectTo: 'employees/:id',
    pathMatch: 'full'
  },
  {
    path: 'hr/settings',
    loadComponent: () => import('../features/hr/hr-settings/hr-settings.component').then(m => m.HrSettingsComponent),
    canActivate: [roleCheckGuard, moduleGuard, permissionGuard],
    data: { requiredPermission: { entity: 'HR_SETTINGS', action: 'READ' }, requiredModule: 'hr' }
  },
  {
    path: 'hr/departments',
    redirectTo: 'hr/settings',
    pathMatch: 'full'
  },
  {
    path: 'hr/employee-groups',
    redirectTo: 'hr/settings',
    pathMatch: 'full'
  },
  {
    path: 'hr/leave-types',
    redirectTo: 'hr/settings',
    pathMatch: 'full'
  },
  {
    path: 'hr/tax-config',
    redirectTo: 'hr/settings',
    pathMatch: 'full'
  },
  {
    path: 'hr/public-holidays',
    redirectTo: 'hr/settings',
    pathMatch: 'full'
  },
  {
    path: 'calendar',
    loadComponent: () => import('../features/hr/calendar/hr-calendar.component').then(m => m.HrCalendarComponent),
    canActivate: [roleCheckGuard, moduleGuard, permissionGuard],
    data: { requiredPermission: { entity: 'EMPLOYEE', action: 'READ' }, requiredModule: 'hr' }
  },
  {
    path: 'portal/products',
    loadComponent: () => import('../shared/components/coming-soon/coming-soon.component').then(m => m.ComingSoonComponent),
    canActivate: [roleCheckGuard, moduleGuard, permissionGuard],
    data: { requiredPermission: { entity: 'PRODUCT', action: 'READ' }, requiredModule: 'onlineSales', title: 'NAV.EXPOSED_PRODUCTS' }
  },
  {
    path: 'portal/requests',
    loadComponent: () => import('../shared/components/coming-soon/coming-soon.component').then(m => m.ComingSoonComponent),
    canActivate: [roleCheckGuard, moduleGuard, permissionGuard],
    data: { requiredPermission: { entity: 'PRODUCT', action: 'READ' }, requiredModule: 'onlineSales', title: 'NAV.REQUESTS' }
  },
  {
    path: 'custom-fields',
    loadComponent: () => import('../features/custom-fields/custom-fields-admin/custom-fields-admin.component').then(m => m.CustomFieldsAdminComponent),
    canActivate: [roleCheckGuard, permissionGuard],
    data: { requiredPermission: { entity: 'REFERENCE_DATA', action: 'READ' } }
  },
  {
    path: 'ai',
    loadComponent: () => import('../features/ai/ai-chat/ai-chat.component').then(m => m.AiChatComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: { entity: 'DASHBOARD', action: 'READ' }, title: 'NAV.AI_ASSISTANT' }
  },
];
